import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 -960 960 960",
  paths: [{
    d: "M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93zM320-360v-66q0-8 3-15.5t9-13.5l209-208q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T663-540L455-332q-6 6-13.5 9t-15.5 3h-66q-17 0-28.5-11.5T320-360zm300-223l-37-37 37 37zM380-380h38l121-122-18-19-19-18-122 121v38zm141-141l-19-18 37 37-18-19z"
  }],
  circles: []
};
var DraftOrdersIcon = function DraftOrdersIcon(props) {
  return renderIcon(props, iconType);
};
export { DraftOrdersIcon };